import React, { useEffect, useRef } from 'react'
import { inject, observer } from 'mobx-react'
import {
  getGoogleClientId,
  promptGoogleOneTap,
  waitForGoogleIdentityServices,
} from '~/utilities/googleIdentityServices'
import { applyGoogleCredentialToAuthStore } from '~/utilities/googleAuth'
import TRACKING from '~/services/tracking'

const ONE_TAP_DISMISSED_KEY = 'winitGoogleOneTapDismissed'

const GoogleOneTap = ({
  auth,
  isLoggedIn,
  isPayNYCFlow,
  isAttemptingLogIn,
  isAttemptingSignUp,
}) => {
  const hasPrompted = useRef(false)

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      hasPrompted.current ||
      isLoggedIn ||
      isAttemptingLogIn ||
      isAttemptingSignUp ||
      !getGoogleClientId()
    ) {
      return
    }

    if (sessionStorage.getItem(ONE_TAP_DISMISSED_KEY) === 'true') {
      return
    }

    let cancelled = false

    const handleCredential = (credential) => {
      applyGoogleCredentialToAuthStore(auth, credential).then((success) => {
        if (success && isPayNYCFlow) {
          TRACKING.paynycParking.oneTapSuccess(isPayNYCFlow)
        }
      })
    }

    const handleNotification = (notification) => {
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        sessionStorage.setItem(ONE_TAP_DISMISSED_KEY, 'true')
      }
      if (notification.isDisplayed() && isPayNYCFlow) {
        TRACKING.paynycParking.oneTapShown(isPayNYCFlow)
      }
    }

    const startOneTap = async () => {
      const ready = await waitForGoogleIdentityServices()
      if (cancelled || !ready || hasPrompted.current) return

      hasPrompted.current = true
      promptGoogleOneTap(handleCredential, handleNotification)
    }

    const timer = window.setTimeout(startOneTap, 500)

    return () => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [auth, isLoggedIn, isPayNYCFlow, isAttemptingLogIn, isAttemptingSignUp])

  return null
}

export default inject((all) => ({
  auth: all.store.auth,
  isLoggedIn: all.store.auth.isLoggedIn,
  isAttemptingLogIn: all.store.auth.isAttemptingLogIn,
  isAttemptingSignUp: all.store.auth.isAttemptingSignUp,
  isPayNYCFlow: all.store.ui.isPayNYCFlow,
}))(observer(GoogleOneTap))
